import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const FILTER_KEY = 'quick_filter_material';

export const useQuickFilterSectionMaterialOpenedState = () => {
  return useOpenedStateManager(FILTER_KEY);
};
